import React from "react";
import NavBar from "./navbar";
//import DogList from './Doglist/doglist';
import DogTab from "./Doglist/dogtab";
import { fire } from "../Firebase/firebase";
import MapContainer from "./map";
import ProfileModal from "./Doglist/profileModal";

export default class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: {
        name: "",
        email: "",
        size: "",
        personality: "",
        gender: "",
        lat: "",
        lng: ""
      },
      data: [],
      isHidden: true,
      clickedUser: null
    };

    this.componentDidMount = this.componentDidMount.bind(this);
    this.getUsers = this.getUsers.bind(this);
    this.setCurrentUser = this.setCurrentUser.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.setCurrentUser();
    this.getUsers();
  }

// Set the currentUser object so that it can be easily accessed in different components
  setCurrentUser() {
    let uid = fire.auth().currentUser.uid;
    var ref = fire.database().ref(`users/` + uid);

    ref.on(
      "value",
      snap => {
        // assign variables that come from snap.val() meaning the values of the snapshot of the db
        const dogName = snap.val() && snap.val().name;
        const email = snap.val() && snap.val().email;
        const size = snap.val() && snap.val().size;
        const gender = snap.val() && snap.val().gender;
        const personality = snap.val() && snap.val().personality;
        const avatar = snap.val() && snap.val().avatar_url;
        const visibility = snap.val() && snap.val().visibility;
        const favUsers = snap.val().favourite_users;
        const ballsCaught = snap.val().caught_balls;

        this.setState({
          currentUser: {
            uid: uid,
            favUsers: favUsers,
            ballsCaught: ballsCaught,
            name: dogName,
            email: email,
            gender: gender,
            size: size,
            personality: personality,
            avatar: avatar,
            visibility: visibility
          }
        });
      },
      function(error) {
        console.log("Error: " + error.code);
      }
    );
  }

  // Get users that will be shown on userlist
  getUsers() {
    var query = fire
      .database()
      .ref("users")
      .orderByKey();
    query.once("value").then(snapshot => {
      snapshot.forEach((childSnapshot, data) => {
        const key = childSnapshot.key;
        const childData = childSnapshot.val();

        const user = {
          id: key,
          name: childData.name,
          personality: childData.personality,
          size: childData.size,
          avatar: childData.avatar_url
        };
        let uid = fire.auth().currentUser.uid;
// Do not show current user, or a user if their visibility is false
        if (childSnapshot.key !== uid && childData.visibility === true ) {
          this.setState({ data: [...this.state.data, user] });
        }
      });
    });
  }

// Handle the click of the profile modal to get the id of the clicked user.
// Toggle profile modal
  handleClick(id) {
    this.setState({
      isHidden: !this.state.isHidden,
      clickedUser: id
    });
  }

  handleClose() {
    this.setState({
      isHidden: !this.state.isHidden
    });
  }

  componentWillUnmount() {
    console.log("unmount");
  }

  render() {
    return (
      <div>
        <MapContainer myLatLng={this.props.currentLocation}>
        <NavBar
          user={this.state.currentUser}
          authenticated={this.props.location.state.authenticated}
        />

        {!this.state.isHidden && (
          <ProfileModal
            currentUser={this.state.currentUser}
            id={this.state.clickedUser}
            handleClose={this.handleClose}
          />
        )}
        <div className="dogs-container">
          {this.state.data.map(data => (
            <DogTab
              key={data.id}
              name={data.name}
              location={data.location}
              personality={data.personality}
              size={data.size}
              avatar={data.avatar}
              uid={data.id}
              handleClick={this.handleClick}
            />
          ))}
        </div>
        </MapContainer>
      </div>
    );
  }
}
